<template>
  <div class="email_validation">
    <header-component
      :is-soon="false"
      :backRoute="true"
      img-left="/trocachip/img/fechar.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />

    <div class="page_content">
      <h2
        class="email_title"
        :class="{ 'ac-color-white': ac }"
        v-if="userHasEmail()"
        v-html="emailValidationPageMessages.title"
      ></h2>
      <h2
        class="email_title"
        :class="{ 'ac-color-white': ac }"
        v-if="!userHasEmail()"
        v-html="emailValidationPageMessages.titleNoEmail"
      ></h2>

      <section class="info_card" id="infocard">
        <section class="card_type_title">
          <img src="../../public/img/ic-exclamation-yellow.svg" alt="alert" />
          <p v-html="emailValidationPageMessages.yellowCardTitle"></p>
        </section>
        <section class="documents_description">
          <label
            v-if="userHasEmail()"
            v-html="emailValidationPageMessages.yellowCardMessage"
          ></label>
          <label
            v-if="!userHasEmail() && !requestEmail()"
            v-html="emailValidationPageMessages.yellowCardMessageNoEmail"
          ></label>
          <br />
          <label
            v-if="!userHasEmail() && requestEmail()"
            v-html="emailValidationPageMessages.yellowCardMessageRequestEmail"
          ></label>
          <br />
          <strong v-if="userHasEmail()">{{
            formatEmail(this.customer.email.toLowerCase())
          }}</strong>
        </section>
      </section>

      <p
        v-if="!isEligible"
        class="eligibility-warn"
        v-html="emailValidationPageMessages.eligibilityWarn"
      />

      <section class="email_value" v-else>
        <label :class="{ 'ac-color-white': ac }">{{
          emailValidationPageMessages.inputLabel
        }}</label>
        <input
          id="emailField"
          type="text"
          autocapitalize="none"
          @blur="validateEmail()"
          @keydown="cleanErrors()"
          @input="transformLowerCase"
          :placeholder="emailValidationPageMessages.inputPlaceholder"
          v-model="email"
          :class="{ 'ac-color-white': ac, 'ac-input': ac }"
        />
        <span
          id="errorIncompleteEmail"
          v-show="errors.invalid"
          class="error-danger"
          :class="{ 'ac-color-yellow': ac }"
          >{{ emailValidationPageMessages.invalidEmailError }}</span
        >
      </section>
      <div class="next_submit">
        <button
          id="submitEmail"
          class="btn_next"
          :class="{
            btn_next_active: !isEligible || isValid,
            'ac-border-yellow': ac,
            'ac-color-yellow': ac,
            'ac-bg-gray': ac,
          }"
          :disabled="isEligible && !isValid"
          @click="next"
        >
          <loader-bottom v-if="loader" />
          <span v-if="!loader">Continuar</span>
        </button>
      </div>
    </div>

    <alert
      v-if="alert.open"
      :description="alert.description"
      :message="alert.message"
      :action="alert.action"
      :success="alert.type == 'success' ? true : false"
      :warning="alert.type == 'alert' ? true : false"
      :danger="alert.type === 'danger'"
      :actionTrigger="alert.actionTrigger"
      :loadingProp="loading"
      @close="alert.open = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "../components/HeaderComponent.vue";
import Alert from "../components/Alert.vue";
import trackEvent from "../services/trackEvent";
import BillingProfile from "../services/billingProfile";
import LoaderBottom from "../components/LoaderBottom.vue";
import EmailVerification from "../services/emailVerification";
import { webCrypto } from "../utils/aesencryption";

export default {
  name: "EmailValidation",
  components: { HeaderComponent, Alert, LoaderBottom },
  data() {
    return {
      email: "",
      errors: {},
      isValid: false,
      loader: false,
      alert: {
        open: false,
      },
      updateEmailConfigMutable: {},
      inclusionEmailConfigMutable: {},
      successEmailConfigMutable: {},
      emailUpdateSuccessConfigMutable: {},
      loading: false,
      isEligible: true,
    };
  },
  watch: {
    email: function () {
      if (this.email.includes("@")) {
        this.validateEmail();
      }
    },
  },
  created() {
    this.sendTracker("confirmar email", 3);
    console.log(this.includeEmailConfig);
    this.updateEmailConfigMutable = this.updateEmailConfig;
    this.inclusionEmailConfigMutable = this.includeEmailConfig;
    this.successEmailConfigMutable = this.successEmailConfig;
    this.emailUpdateSuccessConfigMutable = this.emailUpdateSuccessConfig;
    this.errorUpdateEmailModalConfigMutable = this.errorUpdateEmailModalConfig;
    this.isEligible =
      localStorage.getItem("@trocachip/email-eligibility") !== "false";
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      updateEmailConfig: (state) => state.config.updateEmailModal,
      includeEmailConfig: (state) => state.config.includeEmailModal,
      emailUpdateSuccessConfig: (state) => state.config.emailUpdateSuccessModal,
      successEmailConfig: (state) => state.config.successUpdateEmailModal,
      emailValidationPageMessages: (state) => state.config.emailValidation,
      emailUpdateErrorConfig: (state) => state.config.emailUpdateErrorModal,
      errorUpdateEmailModalConfig: (state) =>
        state.config.errorUpdateEmailModal,
      shouldVerifyEmail: (state) => state.config.verify_email_flag,
      finishingTitles: (state) => state.config.finishingTitles,
      enableFlagEsim: (state) => state.config.enableFlagEsim,
    }),
  },
  methods: {
    userHasEmail() {
      return this.customer.email && !this.customer.email.includes("@tim");
    },
    requestEmail() {
      return this.customer.requestEmail;
    },
    cleanErrors() {
      this.errors.invalid = false;
    },
    maskEmail(email) {
      let [firstPart, ...rest] = email.split("@");
      const firstPartMiddleSize = firstPart.length / 2;
      let stringToReplace = "";

      for (let i = firstPartMiddleSize; i < firstPart.length; i++) {
        stringToReplace += "*";
      }

      firstPart = firstPart.replace(
        firstPart.substring(firstPartMiddleSize, firstPart.length),
        stringToReplace
      );

      return [...firstPart, "@", ...rest].join("");
    },
    proceed() {
      if (this.enableFlagEsim && this.$store.getters.getFlowEsim) {
        this.$router.push({
          name: "finishingScreen",
          params: {
            title: this.finishingTitles.processingTitle,
            changeEmail: false,
            countTime: 0,
          },
        });
      } else if (
        this.$store.getters.getFlowSelected == "chipToESim" ||
        this.$store.getters.getFlowSelected == "eSimToESim"
      ) {
        this.sendTracker("email validado continuar");
        this.$router.push({ name: "loading-page" });
      } else {
        this.$router.push({ name: "instrucoes-barcode" });
      }
    },
    async next() {
      if (!this.isEligible) {
        return this.proceed();
      }

      if (this.shouldVerifyEmail) {
        const isValid = await this.verifyEmail();

        if (!isValid) {
          return this.sendTracker("informe um email válido", 3);
        }
      }
      this.sendTracker("confirmar email continuar");
      if (!this.userHasEmail()) {
        this.openIncludeEmailModal();
        return;
      }

      if (this.customer.email.toLowerCase() != this.email) {
        this.openUpdateEmailModal();
        return;
      }

      this.openValidationSuccessModal();
    },
    async verifyEmail() {
      this.loader = true;

      try {
        const key = process.env.VUE_APP_CONFIG_AES_CRYPT_KEY;
        const cipherText = await webCrypto.simpleEncrypt(this.email.replace(/[^\d]+/g,''), key);
        console.log(cipherText);
        const isValid = await EmailVerification.updateEmail(cipherText);

        if (!isValid) {
          this.alert = {
            open: true,
            actionTrigger: () => {
              this.alert.open = false;
            },
            ...this.emailUpdateErrorConfig,
          };
        }

        return isValid;
      } catch (_) {
        console.error(_);
        this.$router.push({ name: "default-error" });
        return false;
      } finally {
        this.loader = false;
      }
    },
    openValidationSuccessModal() {
      this.successEmailConfigMutable.message =
        this.successEmailConfigMutable.message.replace(
          /\{(.+?)\}/g,
          "[" + this.customer.email + "]"
        );

      this.alert = {
        open: true,
        actionTrigger: () => this.proceed(),
        ...this.successEmailConfigMutable,
      };
    },
    openIncludeEmailModal() {
      this.inclusionEmailConfigMutable.message =
        this.inclusionEmailConfigMutable.message.replace(
          /\{(.+?)\}/g,
          this.email
        );
      this.sendTracker("confirmar inclusao email", 3);
      this.alert = {
        open: true,
        actionTrigger: () => this.makeEmailUpdate(),
        ...this.inclusionEmailConfigMutable,
      };
    },
    nextRoute() {
      if (this.enableFlagEsim && this.$store.getters.getFlowEsim) {
        this.$router.push({
          name: "finishingScreen",
          params: {
            title: this.finishingTitles.processingTitle,
            changeEmail: true,
            email: this.email,
          },
        });
      } else {
        this.loading = true;
        BillingProfile.updateEmail(this.email).then((response) => {
          this.loading = false;
          const responseData = response.data;

          if (!responseData) return;

          responseData.interactionProtocol != ""
            ? this.openSuccesUpdateEmail(responseData.interactionProtocol)
            : this.openModalErrorUpdateEmail();
        });
        this.description == this.includeEmailConfig.description
          ? this.sendTracker("confirmar alteracao email continuar")
          : this.sendTracker("confirmar inclusao email continuar");
        this.emai;
      }
    },
    openUpdateEmailModal() {
      this.updateEmailConfigMutable.message =
        this.updateEmailConfigMutable.message.replace(/\{(.+?)\}/g, this.email);
      this.sendTracker("confirmar alteracao email", 3);
      this.alert = {
        open: true,
        actionTrigger: () => this.makeEmailUpdate(),
        ...this.updateEmailConfigMutable,
      };
    },
    openModalErrorUpdateEmail() {
      this.alert = {
        open: true,
        actionTrigger: () => (this.alert.open = false),
        ...this.errorUpdateEmailModalConfigMutable,
      };
    },
    openSuccesUpdateEmail(protocol) {
      this.sendTracker("email validado", 3);
      if (!this.userHasEmail()) {
        this.emailUpdateSuccessConfigMutable.description =
          this.emailUpdateSuccessConfigMutable.titleInsert;
        this.emailUpdateSuccessConfigMutable.message =
          this.emailUpdateSuccessConfigMutable.message.replace(
            /\{(.+?)\}/g,
            protocol
          );
      } else {
        this.emailUpdateSuccessConfigMutable.description =
          this.emailUpdateSuccessConfigMutable.titleUpdate;
        this.emailUpdateSuccessConfigMutable.message =
          this.emailUpdateSuccessConfigMutable.message.replace(
            /\{(.+?)\}/g,
            protocol
          );
      }

      this.alert = {
        open: true,
        actionTrigger: () => this.proceed(),
        ...this.emailUpdateSuccessConfigMutable,
      };
    },
    makeEmailUpdate() {
      this.loading = true;
      BillingProfile.updateEmail(this.email).then((response) => {
        this.loading = false;
        const responseData = response.data;
        if (!responseData) return;

        responseData.interactionProtocol != ""
          ? this.openSuccesUpdateEmail(responseData.interactionProtocol)
          : this.openModalErrorUpdateEmail();
      });
      this.description == this.includeEmailConfig.description
        ? this.sendTracker("confirmar alteracao email continuar")
        : this.sendTracker("confirmar inclusao email continuar");
      this.nextRoute();
    },
    validateEmail() {
      this.errors.invalid = !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.email);
      this.isValid = !this.errors.invalid;
    },
    sendTracker(eventLabel, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": 6,
        "event-label": eventLabel,
        "event-location": "mvp esim",
        "event-value": this.isExOi() ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    isExOi() {
			if (this.config['init_flow'] === undefined) {
				this.alertError = true;
			}

			return JSON.parse(this.customer.isExOiCustomer);
		},
    transformLowerCase() {
      this.email = this.email.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.email_validation {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 5%;
    > .email_title {
      font-family: "timsans_thin";
      font-size: 1.5rem;
      line-height: 1.875rem;
      text-align: center;
    }
    > .info_card {
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-sizing: border-box;
      border-left: 5px solid #f4b136;
      padding-left: 20px;
      padding-right: 20px;
      margin: 0 auto;
      > .card_type_title {
        display: flex;
        flex-direction: row;
        margin: 10px 0;
        > p {
          color: #f4b136;
          font-size: 0.75em;
          font-family: "timsans_bold";
          padding-left: 8px;
        }
      }
      > .documents_description {
        display: block;
        position: relative;
        font-family: "timsans_regular";
        font-size: 0.875em;
        line-height: 1.43;
        letter-spacing: normal;
        color: #707376;
        margin-bottom: 1rem;
      }
    }
    > .email_value {
      width: 252px;
      height: auto;
      display: block;
      margin: 32px auto 0 auto;
      position: relative;
      > label {
        width: 100%;
        height: 15px;
        font-family: "timsans_regular";
        font-size: 0.75em;
        color: #6c6c6c;
      }
      > input {
        font-size: 12px;
        color: #b3b3b3;
      }
      > img {
        position: absolute;
        top: 52%;
        right: 0;
      }
      > .eligibility-warn {
        max-width: 320px;
        margin: 1.5rem auto 0;
        font-family: "timsans_regular";
        font-size: 14px;
        font-weight: 400;
        line-height: 1.35;
        color: black;
        opacity: 0.6;
        text-align: center;
      }
    }
  }
}
</style>